import classes from './Footer.module.scss';

import UnderlinedLink from '../../UI/UnderlinedLink/UnderlinedLink';

const Footer = () => {
    return (
        <div className={`${classes.footerContainer} Footer_color`}>
            <div className={classes.information}>
                <div>
                    УО "Белорусский государственный
                    университет информатики
                    и радиоэлектроники"
                </div>
                <div>УНП: 100363945</div>
            </div>

            <div className={classes.support}>
                <div className={classes.supportLinks}>
                    <UnderlinedLink href="tel:+375172932222" text="+375 (17) 293-22-22" />
                    <UnderlinedLink href="/support" text="Техподдержка" routing={true}/>
                </div>
                <div>© 2009-{(new Date()).getFullYear()} <UnderlinedLink href="/about" text="ОИТ ЦИИР БГУИР" routing={true}/>. Все права защищены.</div>
            </div>
        </div>
    )
};

export default Footer;